export function getBusinessDate() {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('ja-JP', {
    timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short',
  }).formatToParts(new Date()).map((part) => [part.type, part.value]))
  return {
    iso: `${parts.year}-${parts.month}-${parts.day}`,
    ja: `${parts.year}年${Number(parts.month)}月${Number(parts.day)}日（${parts.weekday}）`,
  }
}
